// Module
var code = `<div class="comment_widget" data-bind="css: {hide_comments_mode: hideComments}">

    <!-- ko if: seedInProgress() -->
        <div class="loading_circle"></div>
    <!-- /ko-->

    <!-- ko if: !seedInProgress() && seed() -->

    <div class="comment_creator">
        <label class="hidden" for="new-comment" data-bind="text: translated('New comment')"></label>
        <textarea class="content" id="new-comment" data-bind="textInput: newComment,
                             attr: {placeholder: newCommentPlaceholder},
                             textareaAutoHeight: maxHeight ? {initialHeight: '24px'} : {},
                             enable: enabled"></textarea>

        <div class="attribute_list" data-bind="foreach: newCommentAttributes()">
            <span class="attribute">
                <!-- ko if: incoherent -->
                    <span class="attribute_label prewrap" data-bind="text: label + ':'"></span>
                    <span class="attribute_value" data-bind="text: content, visible: incoherent"></span>
                <!-- /ko -->
                <!-- ko ifnot: incoherent -->
                    <span class="attribute_label prewrap" data-bind="text: label"></span>
                <!-- /ko -->
                <span data-bind="click: _.partial(\$parent.removeAttribute, \$data)" class="icon_button icon_delete only_icon_img">
               </span>
            </span>
        </div>

        <div class="options" data-bind="visible: _.size(newComment()) || _.size(newCommentAttributes())">
            <div>
                <input type="checkbox" id="reply_pending" data-bind="checked: replyPending">
                <label for="reply_pending" data-bind="text: translated('Request a reply')"></label>
            </div>
        </div>

        <div class="buttons tw:flex tw:gap-1">
            <span class="attributes tw:grow tw:flex tw:gap-1 tw:items-center" data-bind="visible: seed().attributes.length">
                <input type="button" class="add_attribute" data-bind="value: translated('Assign'),
                                  click: addAttribute,
                                  disable: !enabled()
                                           || _.get(selectedAttribute(), 'incoherent')
                                           && _.trim(newCommentAttributeValue()).length < 1">
                <label class="hidden" for="comment_attr_options" data-bind="text: translated('Select an attribute')"></label>
                <select id="comment_attr_options" class="tw:w-52" data-bind="value: selectedAttribute,
                                   options: seed().attributes,
                                   optionsText: 'label', enable: enabled"></select>
                <label class="hidden" for="comment_attr_text" data-bind="text: translated('Insert a comment attribute')"></label>
                <input type="text" id="comment_attr_text" class="tw:grow" data-bind="visible: _.get(selectedAttribute(), 'incoherent'),
                                  textInput: newCommentAttributeValue, enable: enabled">
            </span>

            <span class="actions fake_popup_dialog tw:flex tw:justify-end tw:gap-2 tw:min-h-[22px] tw:py-2" data-bind="if: sendComments">
                <input type="button" data-bind="click: clearComment,
                                  value: translated('Clear'),
                                  enable: enabled() && (newCommentAttributes().length || newComment().length)">
                  <input type="button" class="send confirm" data-bind="click: sendComment,
                                    value: translated('Add'),
                                    enable: enabled()
                                            && (newCommentAttributes().length || _.trim(newComment()).length)
                                            && !(_.get(selectedAttribute(), 'incoherent') && newCommentAttributeValue().length)">
            </span>
        </div>

    </div>

    <!-- ko ifnot: hideComments -->

        <div class="no_data_message" data-bind="visible: seed().comments.length === 0,
                        text: translated('No comments yet')"></div>

        <!-- ko foreach: seed().comments -->

        <div class="comment_bubble" data-bind="css: {is_reply: reply_to_id,
                              reply_to_this:  comment_id === \$parent.replyToId(),
                              blurred_out: !\$parent.isFocused(\$data)}">
             <div class="flexible_container" data-bind="template: {afterRender: \$parent.afterRender}">
                <div class="flex_inside_main_box">
                     <!-- ko if: content && content.length -->
                    <div class="line_comment">
                        <span class="comment_text" data-bind="html: \$parent.convertCommentURL(utils.escapeHtml(content)), css: {'is_reply': reply_to_id}"></span>
                    </div>
                    <!-- /ko -->
                    <!-- ko if: attributes.length -->
                        <div class="line_comment attribute_list tw:w-full" data-bind="foreach: attributes">
                            <span class="attribute created">
                                <!-- ko if: incoherent -->
                                    <span class="attribute_label prewrap" data-bind="text: label + ':'"></span>
                                    <span class="attribute_value" data-bind="text: content, visible: incoherent"></span>
                                <!-- /ko -->
                                <!-- ko ifnot: incoherent -->
                                    <span class="attribute_label prewrap" data-bind="text: label"></span>
                                <!-- /ko -->
                            </span>
                        </div>
                    <!-- /ko -->
                    <div class="comment_meta">
                        <span class="comment_author" style="unicode-bidi: embed" data-bind="text: creator_fullname"></span>
                        (<span class="comment_date" style="unicode-bidi: embed" data-bind="text: created_string"></span>,
                        <!-- ko foreach: _.values(subjects_summary) -->
                            <span class="comment_subjects" style="unicode-bidi: embed" data-bind="text: _.template('<%- amount %> <%- label %>')(\$data),
                                             css: {origin: origin,
                                                   multiple: _.values(\$parent.subjects_summary).length > 1}">
                            </span><!-- ko if: \$index() + 1 < _.values(\$parent.subjects_summary).length -->,<!-- /ko --><!--
                        --><!-- /ko --><!--
                        --><!-- ko if: !_.some(_.map(_.values(subjects_summary), 'origin')) -->
                            <span style="unicode-bidi: embed" data-bind="text: '(' + origin_label + ')'"></span><!--
                        --><!-- /ko -->)
                    </div>
                </div>
                <div class="reply_to_commentactions">
                    <a class="icon_button icon_stepback only_icon_img" data-bind="click: _.partial(\$parent.replyToId, comment_id),
                                  visible: !reply_pending &&
                                           !reply_to_id &&
                                           comment_id !== \$parent.replyToId(),
                                  attr: {title: translated('Click to reply to this comment')}"></a>
                    <a class="icon_button icon_type_confirm only_icon_img warning" data-bind="click: _.partial(\$parent.replyToId, comment_id),
                                  visible: reply_pending &&
                                           !reply_to_id &&
                                           comment_id !== \$parent.replyToId(),
                                  attr: {title: translated('Reply pending. Click to reply to this comment')}"></a>
                    <a class="icon_button icon_delete only_icon_img" data-bind="click: _.partial(\$parent.replyToId, undefined),
                                  visible: !reply_to_id &&
                                           comment_id === \$parent.replyToId(),
                                  attr: {title: translated('Do not reply to this comment')}"></a>

                </div>
            </div>
        </div>

        <!-- /ko -->

    <!-- /ko -->

    <!-- /ko -->
</div>
`;
// Exports
export default code;